import { FC } from "react";
import styles from './styles.module.css';
import { Flex } from "@/kit/antipad-ui/Flex";
import Typography from "@/kit/antipad-ui/Typography";
import { CopyIcon, ExportIcon } from "./icons";
import { formatAddress } from "@/utils/format";
import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "@/hooks";

interface WalletPreviewProps {
    adress: string;
}

export const WalletPreview: FC<WalletPreviewProps> = ({ adress }) => {

    const navigate = useNavigate();
    const { message } = useSnackbar();

    const handleCopyAddress = (address: string) => {
        navigator.clipboard.writeText(address);
        message('Address copied to clipboard', 'success');
    };

    const copyHandle = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        handleCopyAddress(adress);
    }

    const scanHandle = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        window.open(`https://solscan.io/account/${adress}`, '_blank');
    }


    const clickHandle = () => {
        navigate(`/portfolio?address=${adress}`);
    }

    return <Flex onClick={clickHandle} justify="space-between" className={styles.item}>
        <Flex style={{ flex: 1, overflow: 'hidden' }} direction="column" gap="s">
            <Typography style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{formatAddress(adress)}</Typography>
            <Typography color="#44FFA8">View Portfolio</Typography>
        </Flex>
        <Flex style={{ flexShrink: 0 }} gap="m">
            <Flex onClick={copyHandle} className={styles.button}>
                <CopyIcon />
            </Flex>
            <Flex onClick={scanHandle} className={styles.button}>
                <ExportIcon />
            </Flex>
        </Flex>
    </Flex>
}